import { render, staticRenderFns } from "./PriceOptimizationOffline.vue?vue&type=template&id=35a13f88&scoped=true"
import script from "./PriceOptimizationOffline.vue?vue&type=script&lang=js"
export * from "./PriceOptimizationOffline.vue?vue&type=script&lang=js"
import style0 from "./PriceOptimizationOffline.vue?vue&type=style&index=0&id=35a13f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a13f88",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip,QCardSection,QBtn,QRadio,QDialog,QCard,QCardActions,QCheckbox});qInstall(component, 'directives', {ClosePopup});
